namespace GeniuzPOS.Product {
    export interface CsSkuRow {
        Id?: number;
        SkuCode?: string;
        CatCode?: string;
        SubCat1Code?: string;
        SubCat2Code?: string;
        BrandCode?: string;
        CatName?: string;
        SubCat1Name?: string;
        SubCat2Name?: string;
        BrandName?: string;
        StyleId?: string;
        StyleName?: string;
        ColorId?: string;
        ColorName?: string;
        SizeId?: string;
        SizeName?: string;
        TasteId?: string;
        TasteName?: string;
        MatTypeId?: string;
        MatTypeName?: string;
        SkuEnDesc?: string;
        SkuDesc?: string;
        StockFg?: boolean;
        SupplierId?: string;
        SupplName?: string;
        VatType?: string;
        VatTypeDesc?: string;
        VatCode?: string;
        VatRate?: number;
        MarketDate?: string;
        ExpDate?: string;
        ProdImageLink?: string;
        ConsignFg?: boolean;
        ConsignGp?: number;
        ActivePurFg?: boolean;
        ActiveSellFg?: boolean;
        ActiveRepFg?: boolean;
        StkUnit?: string;
        PurUnit?: string;
        PurUnitRatio?: number;
        PurUnitPrice?: number;
        MinStockQty?: number;
        MaxStockQty?: number;
        PurLeadTime?: number;
        QtyOnhand?: number;
        StockCostValue?: number;
        LastPurPrice?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        SkuName?: string;
        UnitList?: CsSkuRow[];
        PluDtList?: PluDtRow[];
        ActiveFg?: number;
        SupplItemCode?: string;
        CusProductTypeNbp?: string;
        CusImportOrLocal?: string;
        CusProductSalesBeforeFlag?: string;
        CusProductSalesBeforeRefer?: string;
        CusProductSalesBeforeReferFlag?: string;
        NonAllowtoDiscountFg?: boolean;
        ProductCpDesc1?: string;
        ProductCpDesc2?: string;
        ProductCpComponent?: string;
        ProductCpHowToUse?: string;
        ProductCpWarning?: string;
        SetItemFg?: boolean;
        ProductType?: number;
        ArticleSeasonCode?: string;
        BrandTypeCode?: string;
        ConceptCode?: string;
        PurVatType?: string;
        PurVatCode?: string;
        MinOrderQty?: number;
        MaxOrderQty?: number;
        ShelfLifeTime?: number;
        LastStockCostUnit?: number;
    }

    export namespace CsSkuRow {
        export const idProperty = 'SkuCode';
        export const nameProperty = 'SkuName';
        export const localTextPrefix = 'Product.CsSku';
        export const lookupKey = 'CsSkuRow';

        export function getLookup(): Q.Lookup<CsSkuRow> {
            return Q.getLookup<CsSkuRow>('CsSkuRow');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            SkuCode = "SkuCode",
            CatCode = "CatCode",
            SubCat1Code = "SubCat1Code",
            SubCat2Code = "SubCat2Code",
            BrandCode = "BrandCode",
            CatName = "CatName",
            SubCat1Name = "SubCat1Name",
            SubCat2Name = "SubCat2Name",
            BrandName = "BrandName",
            StyleId = "StyleId",
            StyleName = "StyleName",
            ColorId = "ColorId",
            ColorName = "ColorName",
            SizeId = "SizeId",
            SizeName = "SizeName",
            TasteId = "TasteId",
            TasteName = "TasteName",
            MatTypeId = "MatTypeId",
            MatTypeName = "MatTypeName",
            SkuEnDesc = "SkuEnDesc",
            SkuDesc = "SkuDesc",
            StockFg = "StockFg",
            SupplierId = "SupplierId",
            SupplName = "SupplName",
            VatType = "VatType",
            VatTypeDesc = "VatTypeDesc",
            VatCode = "VatCode",
            VatRate = "VatRate",
            MarketDate = "MarketDate",
            ExpDate = "ExpDate",
            ProdImageLink = "ProdImageLink",
            ConsignFg = "ConsignFg",
            ConsignGp = "ConsignGp",
            ActivePurFg = "ActivePurFg",
            ActiveSellFg = "ActiveSellFg",
            ActiveRepFg = "ActiveRepFg",
            StkUnit = "StkUnit",
            PurUnit = "PurUnit",
            PurUnitRatio = "PurUnitRatio",
            PurUnitPrice = "PurUnitPrice",
            MinStockQty = "MinStockQty",
            MaxStockQty = "MaxStockQty",
            PurLeadTime = "PurLeadTime",
            QtyOnhand = "QtyOnhand",
            StockCostValue = "StockCostValue",
            LastPurPrice = "LastPurPrice",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            SkuName = "SkuName",
            UnitList = "UnitList",
            PluDtList = "PluDtList",
            ActiveFg = "ActiveFg",
            SupplItemCode = "SupplItemCode",
            CusProductTypeNbp = "CusProductTypeNbp",
            CusImportOrLocal = "CusImportOrLocal",
            CusProductSalesBeforeFlag = "CusProductSalesBeforeFlag",
            CusProductSalesBeforeRefer = "CusProductSalesBeforeRefer",
            CusProductSalesBeforeReferFlag = "CusProductSalesBeforeReferFlag",
            NonAllowtoDiscountFg = "NonAllowtoDiscountFg",
            ProductCpDesc1 = "ProductCpDesc1",
            ProductCpDesc2 = "ProductCpDesc2",
            ProductCpComponent = "ProductCpComponent",
            ProductCpHowToUse = "ProductCpHowToUse",
            ProductCpWarning = "ProductCpWarning",
            SetItemFg = "SetItemFg",
            ProductType = "ProductType",
            ArticleSeasonCode = "ArticleSeasonCode",
            BrandTypeCode = "BrandTypeCode",
            ConceptCode = "ConceptCode",
            PurVatType = "PurVatType",
            PurVatCode = "PurVatCode",
            MinOrderQty = "MinOrderQty",
            MaxOrderQty = "MaxOrderQty",
            ShelfLifeTime = "ShelfLifeTime",
            LastStockCostUnit = "LastStockCostUnit"
        }
    }
}
